import React from 'react';
import functions from '../util/functions';

const JournalEntryTable = ({ journal_id, date, description, entries, created_by }) => {

    // Calculate totals
  const totalDebit = entries.reduce((sum, entry) => sum + parseFloat(entry.debit || 0), 0);
  const totalCredit = entries.reduce((sum, entry) => sum + parseFloat(entry.credit || 0), 0);

    return (
    <div className="journal-entry">
      <h3>Journal Entry #{journal_id}</h3>
      <p>Transaction Date: {functions.formatDate(date)}</p>
      <p>Description: {description}</p>
      <p>Created By: {created_by.full_name} - {created_by.username}</p>

      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Account</th>
            <th>Description</th>
            <th>Debit</th>
            <th>Credit</th>
          </tr>
        </thead>
        <tbody>
          {entries.map((entry, index) => (
            <tr key={index}>
              <td>{entry.account.account_name}</td>
              <td>{entry.description}</td>
              <td>{entry.debit > 0 ? functions.numberFormat(entry.debit) : ""}</td>
              <td>{entry.credit > 0 ? functions.numberFormat(entry.credit) : ""}</td>
            </tr>
          ))}
          <tr>
            <td colSpan="2" style={{ textAlign: "right", fontWeight: "bold" }}>Total</td>
            <td style={{fontWeight: 'bold'}}>{functions.numberFormat(totalDebit)}</td>
            <td style={{fontWeight: 'bold'}}>{functions.numberFormat(totalCredit)}</td>
          </tr>
        </tbody>
      </table>
    </div>
    );
};

export default JournalEntryTable;